module.exports = __webpack_public_path__ + "static/img/ap6.cd7fe2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap6.jpg
// module id = LUcD
// module chunks = 1